/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Marked_AppliedInputs */

const en_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked as applied`)
};

const de_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als beworben markiert`)
};

const fr_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqué comme postulé`)
};

const es_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcado como postulado`)
};

const it_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnata come candidata`)
};

const nl_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemarkeerd als gesolliciteerd`)
};

const pl_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznaczono jako wysłaną`)
};

const fi_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkitty haetuksi`)
};

const da_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markeret som ansøgt`)
};

const sv_jobs_marked_applied = /** @type {(inputs: Jobs_Marked_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerad som ansökt`)
};

/**
* | output |
* | --- |
* | "Marked as applied" |
*
* @param {Jobs_Marked_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_marked_applied = /** @type {((inputs?: Jobs_Marked_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Marked_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_marked_applied(inputs)
	if (locale === "fr") return fr_jobs_marked_applied(inputs)
	if (locale === "es") return es_jobs_marked_applied(inputs)
	if (locale === "it") return it_jobs_marked_applied(inputs)
	if (locale === "nl") return nl_jobs_marked_applied(inputs)
	if (locale === "pl") return pl_jobs_marked_applied(inputs)
	if (locale === "fi") return fi_jobs_marked_applied(inputs)
	if (locale === "da") return da_jobs_marked_applied(inputs)
	if (locale === "sv") return sv_jobs_marked_applied(inputs)
	return en_jobs_marked_applied(inputs)
});